import { Fade } from "react-awesome-reveal";
import { FaChevronCircleRight } from "react-icons/fa";
import { Link } from "react-scroll";
import { LINKSNAVBAR } from "../../../store/LinksNavbar";

export default function QuickLinks() {
  return (
    <div className="flex-1 space-y-6">
      <h3 className="text-2xl">QuickLinks</h3>

      <Fade cascade damping={0.1}>
        <ul className="leading-8">
          {LINKSNAVBAR.slice(0, LINKSNAVBAR.length - 1).map((obj) => (
            <li key={obj.key} className="cursor-pointer">
              {/* link react-scroll when you are scroll the page */}
              <Link
                smooth
                to={obj.link}
                className="flex items-center flex-1 gap-3 hover:text-primary-green"
              >
                <FaChevronCircleRight />
                {obj.name}
              </Link>
            </li>
          ))}
        </ul>
      </Fade>
    </div>
  );
}
